<template>
  <div class="tab-main">
    <swiper
      :options="{
        slidesPerView: 'auto',
        freeMode: true,

      }"
      class="swiper"
    >
      <swiper-slide
        :class="{
          active: $route.query.goodstype == '0' || !$route.query.goodstype,
        }"
      >
        <div
          @click="
            $router
              .push({
                name: 'FittingList',
                query: { goodstype: '0' },
              })
              .catch(() => {})
          "
        >
          {{ $t("filter.common.total") }}
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: $route.query.goodstype == 1 }">
        <div
          @click="
            $router
              .push({
                name: 'FittingList',
                query: { goodstype: 1 },
              })
              .catch(() => {})
          "
        >
          {{ $t("filter.common.driver") }}
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: $route.query.goodstype == 2 }">
        <div
          @click="
            $router
              .push({
                name: 'FittingList',
                query: { goodstype: 2 },
              })
              .catch(() => {})
          "
        >
          {{ $t("filter.common.wood") }}
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: $route.query.goodstype == 3 }">
        <div
          @click="
            $router
              .push({
                name: 'FittingList',
                query: { goodstype: 3 },
              })
              .catch(() => {})
          "
        >
          {{ $t("filter.common.utility") }}
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: $route.query.goodstype == 4 }">
        <div
          @click="
            $router
              .push({
                name: 'FittingList',
                query: { goodstype: 4 },
              })
              .catch(() => {})
          "
        >
          {{ $t("filter.common.iron") }}
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: $route.query.goodstype == 5 }">
        <div
          @click="
            $router
              .push({
                name: 'FittingList',
                query: { goodstype: 5 },
              })
              .catch(() => {})
          "
        >
          {{ $t("filter.common.wedge") }}
        </div>
      </swiper-slide>
      <swiper-slide :class="{ active: $route.query.goodstype == 6 }">
        <div
          @click="
            $router
              .push({
                name: 'FittingList',
                query: { goodstype: 6 },
              })
              .catch(() => {})
          "
        >
          {{ $t("filter.common.putter") }}
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "Tab",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      /*swiperOptions: {
        slidesPerView: 'auto',
        freeMode: true
      }*/
    };
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log("slide change");
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  mixins: [myMixin],
};
</script>
